import request from '@/axios'

// 云客微信聊天tab-列表
export function getDetailList(data) {
  return request({
    url: '/yk/set/get/wechat/connection/list',
    data
  })
}

// 详情页-单聊微信聊天记录
export function getSingleWxChatRecord(data) {
  return request({
    url: '/ykMobile/getSingleWxChatRecord',
    data
  })
}

// 详情页-群聊微信聊天记录
export function getGroupWxChatRecord(data) {
  return request({
    url: '/ykMobile/getGroupWxChatRecord',
    data
  })
}

// 判断是否是云客手机
export function isYunkePhone(data) {
  return request({
    url: '/ykMobile/check/work/phone',
    data
  })
}

// 云客外呼
export function isYunkeCall(data) {
  return request({
    url: '/ykMobile/phone/call',
    data
  })
}
